import React, { Component } from "react";
import { connect } from "react-redux";
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import { otherInfoUpate } from '../../actions/loginActions'
import { isValidCharacter } from "../../utils";
import $ from 'jquery'

const isValidNumber = (n) => {
    return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
}

const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};


class TakeUserEmail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            accountCompanyName: null,
            acnError: null,
            phoneError: null,
            phone: null,
            country_code: null,
            emailError:null,
            acnErrorMsg: "Company Name is required.",
            emailErrorMsg:'Email is not valid',
            email:'',
            loading:false
        }
    }
    onEmailChange = event => this.setState({ email: event.target.value, emailError: validateEmail(event.target.value) ? null : true, emailErrorMsg: '' })

    onInTelLoad = () => {

        var errorMsg = document.querySelector("#error-msg"),
            validMsg = document.querySelector("#valid-msg");
        var submitBtn = document.getElementById('register-submit-btn');
        var contactError = document.getElementById('contact-error');

        var input = document.querySelector("#phone");

        if (input) {
            var reset = function () {
                input.classList.remove("error");
                errorMsg.innerHTML = "";
                errorMsg.classList.add("hide");
                submitBtn.disabled = false;

            };
            input.addEventListener('blur', function () {
                reset();
                var contactNo = input.value.trim();

                if (contactNo) {

                    if (isNumber(contactNo)) {
                        validMsg.classList.remove("hide");
                        submitBtn.disabled = false;
                        contactError.style.display = "none";

                    } else {
                        input.classList.add("error");
                        errorMsg.classList.remove("hide");
                        submitBtn.disabled = true;
                        contactError.style.display = "none";

                    }

                }
            });
            input.addEventListener('change', reset);
            input.addEventListener('keyup', reset);
            function isNumber(n) {
                return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
            }
        }
    }
    

    onACNChange = event => {

        let validChar = isValidCharacter(event.target.value);
        validChar == true ?
            this.setState({ accountCompanyName: event.target.value, acnError: null })
            :
            this.setState({
                accountCompanyName: event.target.value, acnError: true,
                acnErrorMsg:
                    validChar == 2 ? "Special characters are not allowed. Enter Proper Company Name" :
                        "Company Name is required."
            })
    }

    onClickToFinish = event => {
        const { history, signUpData } = this.props
         
        const { accountCompanyName, phone, country_code,emailError,email } = this.state;
        if (!emailError && email && String(email).length > 0) {
            this.setState((state)=>({...state,loading:true}))
            this.props.otherInfoUpate({organization: accountCompanyName, contact_no: phone, country_code: country_code,email:email }, history, signUpData.activeProduct)
        }else{
            this.setState((state)=>({...state,emailError:true,emailErrorMsg:email.length>0?'Email is not valid':"Please enter your email",loading:false}))
        }
    }

    componentDidMount() {
        this.onInTelLoad()

        function isNumber(n) {
            return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
        }

        window.$(".input-phone").on('keypress', function () {
            if (!isNumber(this.value)) {
                $(".input-phone").val(null);
           }
        });
    }

    updatePhoneNumber1 = (isValid, value, selectedCountryData, fullNumber, extension) => {


        var errorMsg = document.querySelector("#error-msg"),
            validMsg = document.querySelector("#valid-msg");
        var submitBtn = document.getElementById('register-submit-btn');
        var contactError = document.getElementById('contact-error');
        var input = document.querySelector("#phone");
        if (value) {
            if (isValid && isValidNumber(value)) {
                validMsg.classList.remove("hide");
                validMsg.innerHTML = "✓ Valid";
                submitBtn.disabled = false;
                contactError.style.display = "none";
                this.setState({ phone: value, country_code: selectedCountryData.dialCode })

            } else {
                input.classList.add("error");
                errorMsg.innerHTML = "Invalid number";
                errorMsg.classList.remove("hide");
                validMsg.innerHTML = "";
                validMsg.classList.add("hide");
                submitBtn.disabled = true;
                contactError.style.display = "none";
            }
        }
    }

    render() {
        const { accountCompanyName,loading, acnError, acnErrorMsg,emailErrorMsg,emailError,email } = this.state;

        return <>
            <div className="loginFormSec registerFormSec formControlMin">
                <div className="loginWithSocials">
                    <div className="loginHead">
                        <h2>Almost Done !</h2>
                        <p>Please enter your Email Address</p>
                    </div>
                </div>
                <div className="loginBlock">
                    <div className="loginInnSec">
                        <div id="AccountOtherinfoForm">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="form-group labelPosition">
                                        <label htmlFor="Email">Email Id</label>
                                        <input name="data[Account][company_name]" className={`form-control placeholder-no-fix ${emailError ? ` form-error` : ``}`} type="text" value={email} id="AccountCompanyName" data-factors-input-id="form-0.field-0" onChange={this.onEmailChange}/>
                                        {emailError ? <span className="errorMessage">{emailError && emailErrorMsg.length > 0 ? emailErrorMsg : `Email is not valid.`}</span> : null}
                                    </div>

                                    <div className="form-group labelPosition">
                                        <label htmlFor="AccountCompanyName">Company Name</label>
                                        <input name="data[Account][company_name]" className={`form-control placeholder-no-fix ${acnError ? ` form-error` : ``}`} type="text" value={accountCompanyName} id="AccountCompanyName" data-factors-input-id="form-0.field-0" onChange={this.onACNChange}/>
                                        {acnError ? <span className="errorMessage">{acnErrorMsg}</span> : null}
                                    </div>
                                    <div className="form-group labelPosition">
                                        <input type="hidden" name="data[Account][country_code]" id="country_code" className="form-control placeholder-no-fix" val="1" />
                                        <label htmlFor="phone">Contact No </label>
                                        <IntlTelInput fieldId="phone"
                                            style={{ width: `100%` }}
                                            preferredCountries={['IN']}
                                            onPhoneNumberBlur={this.updatePhoneNumber1}
                                            containerClassName="intl-tel-input"
                                            inputClassName="form-control input-phone placeholder-no-fix" autocomplete="off" data-intl-tel-input-id="0" placeholder="9987654321" data-factors-input-id="form-0.field-1"
                                        />

                                        <div id="contact-error">
                                        </div>
                                        <div id="error-msg" className="hide" style={{ left: 0, color: '#d41220', font: "400 12px/25px 'open sans', sans-serif" }}></div>
                                        <div id="valid-msg" className="hide" style={{ left: 0, color: 'green', font: "400 12px/25px 'open sans', sans-serif" }}></div>

                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div style={{ clear: 'both' }}></div>
                                    <div className="form-group">
                                        <button onClick={this.onClickToFinish} id="register-submit-btn" data-style="expand-left" className={`btn btn-primary w-100 ${loading ? 'spinner spinner-right disabled':''}`}>
                                            Let's Go
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clear"></div>
            </div>
        </>
    }
}
const mapStateToProps = (state) => {
    return {
        signUpData: state.signUp.signUpData
    }
}
const mapDispatchToProps = dispatch => {
    return {
        otherInfoUpate: (data, history, redirect) => dispatch(otherInfoUpate(data, history, redirect)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(TakeUserEmail);